import Navigation from "../navigation";
import styles from "./styles.module.scss";
import Menus from "../../../data/menus";
import StorageActions from "./StorageActions";
export default function Header() {
  return (
    <header className={styles.header}>
      <StorageActions />
      <Navigation menu={Menus.MainMenu} orientation="horizontal" />
    </header>
  );
}
